import { useQuery } from '@tanstack/react-query'
import { paymentApprovalApi } from '../api'
import { paymentApprovalKeys } from '../keys'
import { QueryOptionsWithoutKeyAndFn } from '@/lib/tanstack-utils.types'
import { RulesUsageArray } from '../schema'

export default function useGetPaymentRuleApplications({
  programId,
  ruleId,
  options,
}: {
  programId: number
  ruleId: number
  options: QueryOptionsWithoutKeyAndFn<RulesUsageArray>
}) {
  return useQuery({
    queryFn: () =>
      paymentApprovalApi.getPaymentApprovalRuleApplications({
        programId,
        ruleId,
      }),
    queryKey: paymentApprovalKeys.paymentApprovalRules({
      programId,
      ruleId,
    }),
    ...options,
  })
}
